import * as types from 'redux/actions/actionTypes';
import axiosError from './axiosError';

const initialState = {
  isFetching: false
};

export default function course(state = initialState, action) {
  switch (action.type) {
    case types.GET_COURSE_PENDING: {
      return {
        ...state,
        isFetching: true
      };
    }

    case types.GET_COURSE_SUCCESS: {
      return {
        ...state,
        ...action.payload.result,
        isFetching: false,
        error: undefined
      };
    }

    case types.GET_COURSE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: axiosError(state.error, action)
      };

    default:
      return state;
  }
}

export const isFetching = (state) => state && state.course && state.course.isFetching;

export const getCourse = (state) => state && state.course;
